import Swiper from 'swiper';

let viewportWidth = document.documentElement.clientWidth;
let mobSwipeArray = [];

function initSwipe() {

  $('.js-mob-swipe').each(function (index) {
    if (viewportWidth < 768 && mobSwipeArray[index] == undefined) {
      $(this).addClass(`swm-${index}`);

      mobSwipeArray.push(new Swiper(`.swm-${index}.swiper-container`, {
        slidesPerView: 'auto',
        freeMode: true,
      }));

    } else if (viewportWidth >= 768 && mobSwipeArray[index] != undefined) {
      mobSwipeArray[index].destroy();
      mobSwipeArray.splice(index, 1);
    }
  });
}

if ($('.js-mob-swipe').length) {
  initSwipe();
}

$(window).resize(function () {
  viewportWidth = document.documentElement.clientWidth;
  setTimeout(() => {
    initSwipe();
  }, 100);
});


// Select to slider content
$('.js-select-tab').on('select2:select', function (e) {
  const data = e.params.data;

  $(this).closest('.tabs').find('.tabs__content').siblings()
    .removeClass('active').eq(data.id).addClass('active');

  mobSwipeArray.forEach(function (el) {
    el.update();
  });
});